if(typeof FN == 'undefined') FN = {};

function setupTOC() {
  // Look up DOM elements and offsets once, store in array
  let data = [];
  const h2s = document.querySelectorAll('#post-detail h2')

  const filteredH2s = Array.from(h2s).filter(h2 => h2.parentElement.className !== 'signup--block__join--email' &&
    h2.parentElement.className !== 'download-tower-framed' &&
    h2.parentElement.className !== 'incentive-download__text' &&
    h2.parentElement.className !== 'signup--gift__text' &&
    h2.parentElement.className !== 'table-of-contents'
  )
  if (filteredH2s.length == 0) { return }

  const tocList = document.querySelector('.table-of-contents ul')
  // Absence of TOC list element may indicate TOC has been disabled for this post
  if (!tocList) { return }

  const tocItems = tocList.querySelectorAll('li a[href^="#"]')

  // Build data array for scroll tracking
  filteredH2s.forEach((h2, index) => {
    const tocItem = tocItems[index + 1] // +1 to skip the "Introduction" item
    if (tocItem) {
      data.push({
        heading: h2,
        item: tocItem.parentElement,
        link: tocItem,
        offsetTop: h2.offsetTop,
        offsetBottom: h2.offsetTop + h2.offsetHeight
      });
    }
  });

  const intro = document.querySelector('.intro');
  const introItem = document.querySelector('.table-of-contents ul li');
  let highlighted;

  function readingIndicator() {
    const lastKnownScrollPosition = {
      top: window.pageYOffset,
      bottom: window.pageYOffset + document.documentElement.clientHeight / 2
    };

    if (highlighted) {
      highlighted.classList.remove('now-reading');
    }

    // Find which heading to highlight
    highlighted = introItem;
    for (let i = 0; i < data.length; i++) {
      if (lastKnownScrollPosition.bottom >= data[i].offsetBottom) {
        highlighted = data[i].item;

        if (lastKnownScrollPosition.top <= data[i].offsetTop) {
          break;
        }
      }
    }

    highlighted.classList.add('now-reading');
  }

  document.addEventListener('scroll', function () {
    readingIndicator();
  });

  // Highlight initial item
  readingIndicator();
}

$(document).ready(function(){
  /*********** Configure Analytics Event Tracking */
  var postAnalyticsEvents = [
    /* Newsletter Subscription */
    { 'config': { 'selector': '.signup--block.post-footer .newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
      'event':  { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': 'post-footer' }
    },
    { 'config': { 'selector': '.signup--block.post-middle .newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
      'event':  { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': 'post-middle' }
    },
    /* Social Follow */
    { 'config': { 'selector': '.signup--block .social-button--twitter.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'follow', 'eventLabelSuffix': 'post/twitter' }
    },
    { 'config': { 'selector': '.signup--block .social-button--rss.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'rss', 'eventLabelSuffix': 'post/rss' }
    },
    /* Social Share */
    { 'config': { 'selector': '#sharing-sidebar .social-button--twitter.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'post/sidebar/twitter' }
    },
    { 'config': { 'selector': '#sharing-sidebar .social-button--facebook.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'post/sidebar/facebook' }
    },
    { 'config': { 'selector': '#sharing-sidebar .social-button--linkedin.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'post/sidebar/linkedin' }
    },
    /* Page Links */
    { 'config': { 'selector': '.footer-container .tower-site-link.analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': 'post/footer/tower-website' }
    },
    { 'config': { 'selector': '.footer-container .read-next-link.analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'post-content', 'eventLabelSuffix': 'post/footer/read-next-post' }
    },
    /* Content Downloads */
    { 'config': { 'selector': '.incentive-download--incentive_cheatpackage .analytics--click' },
      'event':  { 'eventCategory': 'content', 'eventAction': 'download', 'eventLabelSuffix': 'post/incentive/cheat-sheet-package' }
    },
    /* Post-Specific Trackings */
    { 'config': { 'selector': '.incentive--cheatsheet-package .analytics--submit', 'triggerOnlyOnce': true },
      'event':  { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': 'post/incentive/cheat-sheet-package' }
    },
    { 'config': { 'selector': '.download-workflow-of-vcs-cheatsheet.analytics--click' },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'download', 'eventLabelSuffix': 'workflow-of-vcs-cheat-sheet' }
    },
    { 'config': { 'selector': '.download--ridiculously-agile.analytics--click' },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'download', 'eventLabelSuffix': 'post/incentive/ridiculously-agile' }
    }
  ];

  FN.analytics.addConfiguredEvents(postAnalyticsEvents);
});

window.addEventListener('load', setupTOC);
